import { render, staticRenderFns } from "./Leaderboard_Section_Header.vue?vue&type=template&id=e354876e&"
import script from "./Leaderboard_Section_Header.vue?vue&type=script&lang=js&"
export * from "./Leaderboard_Section_Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports